import { getCurrentInstance, h, ref, unref, watchEffect } from "@vue/composition-api";
import { InputUserPublicDataSearch } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import { userPublicDataFieldsWithStoryInfo } from "@/lib/fieldsHelper";

const DEFAULT_SIZE = 20;

export default function usePromotedUsers(requestInput?: InputUserPublicDataSearch) {
  const loading = ref(false);
  const { enableScroll, items: list, getNextPage, getFirstPage } = usePager<UserPublicData, InputUserPublicDataSearch>(
    async page => {
      try {
        loading.value = true;
        return await providers.UserPublicDataProvider.search(
          {
            data: {
              page,
              size: DEFAULT_SIZE,
              sort: "FOLLOWER_COUNT,DESC;ID",
              discovery: true,
              ...requestInput,
            },
          },
          userPublicDataFieldsWithStoryInfo()
        );
      } finally {
        loading.value = false;
      }
    }
  );

  const vm = getCurrentInstance();
  watchEffect(() => vm?.$emit("loading", loading.value));

  const render = () => {
    const nodes =
      (vm?.$scopedSlots.default &&
        vm?.$scopedSlots.default({
          list: unref(list),
          enableScroll: unref(enableScroll),
          loading: unref(loading),
          getNextPage,
        })) ||
      [];
    if (nodes.length === 1) return nodes[0];
    else return h("div", nodes);
  };

  return {
    loading,
    list: unref(list),
    getNextPage,
    enableScroll,
    getFirstPage,
    render,
  };
}
